import { ReactElement, useContext } from "react";
import { ILRFProduction, IProductionExtended } from "../../../types";
import { TextField } from "@mui/material";
import { formatDateTimeWithSeconds } from "../../../system/utils";
import { SystemContext } from "../../../context/systemContext";
import { getLanguage } from "../../production/configuration/language";

interface IGeneralPanelProps {
  productionItem: IProductionExtended;
}


const LRFGeneralPanel = ({ productionItem }: IGeneralPanelProps): ReactElement => {
  const systemContext = useContext(SystemContext);

  const heat = productionItem as ILRFProduction;

  const temperature = {
    datetime: 0,
    value: 0
  };

  productionItem.variables.forEach(variable => {
    if (variable.datetime > temperature.datetime) {
      temperature.datetime = variable.datetime;
      temperature.value = variable.value as number;
    }
  });

  return(
    <div className="display-flex-row flex-wrap">
      <div className="flex-grow-1" style={{ maxWidth: 1600 }}>
        <TextField className="form-control"
          variant="standard"
          size="small"
           slotProps={{ input: { readOnly: true } }}
          label={"Machine"}
          defaultValue={productionItem.machine.name}/>

        <TextField className="form-control"
          variant="standard"
           slotProps={{ input: { readOnly: true } }}
          label={getLanguage(systemContext.languageCode).heatNumber}
          defaultValue={heat.heatNumber}/>

        <TextField className="form-control"
          variant="standard"
           slotProps={{ input: { readOnly: true } }}
          label={getLanguage(systemContext.languageCode).grade}
          defaultValue={heat.steel.code}/>

        <TextField className="form-control-large"
          variant="standard"
           slotProps={{ input: { readOnly: true } }}
          label={getLanguage(systemContext.languageCode).begin}
          defaultValue={formatDateTimeWithSeconds(productionItem.beginDatetime)}/>

        <TextField className="form-control-large"
          variant="standard"
           slotProps={{ input: { readOnly: true } }}
          label={getLanguage(systemContext.languageCode).end}
          defaultValue={formatDateTimeWithSeconds(productionItem.endDatetime)}/>

        <TextField className="form-control"
          variant="standard"
           slotProps={{ input: { readOnly: true } }}
          label={systemContext.language.crew}
          defaultValue={productionItem.crew.name}/>

        <TextField className="form-control"
          variant="standard"
           slotProps={{ input: { readOnly: true } }}
          label={getLanguage(systemContext.languageCode).ladle}
          defaultValue={heat.ladleHistory ? heat.ladleHistory.ladle : "---"}/>

        <TextField className="form-control"
          variant="standard"
                   slotProps={{ input: { readOnly: true } }}
          label="KWH"
          defaultValue={heat.kwh ? heat.kwh : "---"}/>

        <TextField className="form-control"
          variant="standard"
           slotProps={{ input: { readOnly: true } }}
          label="Last LRF Temp"
          defaultValue={heat.lastTemp ? heat.lastTemp : "---"}/>

        <TextField className="form-control"
          variant="standard"
         slotProps={{ input: { readOnly: true } }}
          label="Last LRF O2 PPM"
          defaultValue={heat.lastO2PPM ? heat.lastO2PPM: "---"}/>

        {/*</Paper>*/}

      </div>
    </div>
  );
};

export default LRFGeneralPanel;
